module.exports = __webpack_public_path__ + "img/top-bar.8c135c0b.png";